import { QuestionComponentProps } from "..";

import { CompanySizeSelector } from "./components/CompanySizeSelector";

export function CompanySize({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <CompanySizeSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
